import { useRouter } from '@application/utils';
import { Button, Container } from '@presentation/components';
import { useTranslation } from '@presentation/utils';
import type { FC } from 'react';
import * as RootStyled from '../../styled';
import cards from '../assets/cards.webp';
import labelsFR from '../assets/labelsFR.svg';
import labelsNL from '../assets/labelsNL.svg';
import * as Styled from './styled';

const labels = {
  fr: labelsFR,
  nl: labelsNL,
};

export const RewardsSection: FC = () => {
  const { translate } = useTranslation();
  const { language, routeLocationDescriptor } = useRouter();

  return (
    <Container>
      <Styled.Wrapper>
        <div>
          <RootStyled.Title color="purple">
            {translate('breederLanding.rewards.title')}
          </RootStyled.Title>
          <p>{translate('breederLanding.rewards.text')}</p>

          {!!labels[language] ? <img src={labels[language]} alt="" width="300" /> : null}
          <Styled.Button>
            <Button color="blue" size="large" shrink link={routeLocationDescriptor('joinBreeder')}>
              {translate('common.buttons.registerAsBreeder')}
            </Button>
          </Styled.Button>
        </div>

        <Styled.Image>
          <img src={cards} alt="" width="100%" />
        </Styled.Image>
      </Styled.Wrapper>
    </Container>
  );
};
